import { Checkbox } from '../Checkbox';
import { StyledQmarkCheckboxes } from './style';
import { useIntl } from 'react-intl';
import React, { useEffect, useState } from 'react';
import { QmarkFilterOptions } from 'types/FilterOptions';
import { Icon } from 'ui';

interface QmarkProps {
  qmarks: QmarkFilterOptions[] | undefined;
}

export const QualityMarkCheckboxes = ({ qmarks }: QmarkProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEmpty, setIsEmpty] = useState<boolean>();

  const intl = useIntl();

  const handleOnClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const isEmpty = !qmarks || qmarks.length === 0;

    if (isOpen) {
      setIsOpen(!isEmpty);
    }

    setIsEmpty(isEmpty);
  }, [qmarks]);

  return (
    <StyledQmarkCheckboxes>
      <div
        className={'qmark-filter-title'}
        onClick={!isEmpty ? handleOnClick : undefined}
      >
        <div>{intl.formatMessage({ id: 'form.qmark_filter_title' })}</div>
        <div className={`icon ${!isOpen ? 'collapsed' : ''}`}>
          <Icon name="arrow" />
        </div>
      </div>

      {isOpen && <Checkbox name="qmark" options={qmarks} filterView={true} />}
    </StyledQmarkCheckboxes>
  );
};
